import { observer } from 'mobx-react-lite';
import CloseIcon from '@mui/icons-material/Close';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import { Badge, Stack, Tab, Tabs } from '@mui/material';

import { AppLayout } from '@/dmdrive/core/constants/layout';
import { useStore } from '@/dmdrive/store';
import { useTopicStore } from '@/dmdrive/topic/components/Topic/TopicStore';

import { SidebarTab } from '../TopicStore.constants';

import { CloseRightSidebar, RightSidebarContent, RightSidebarRoot } from './RightSidebar.styles';

import Participants from './Participants/Participants';
import Remarks from './Remarks/Remarks';

function RightSidebar() {
  const { layout } = useStore('appStore');
  const { topic, activeTab, setActiveTab, isRightSidebarOpen, toggleRightSidebar, masterRequestCount } =
    useTopicStore();

  return (
    <RightSidebarRoot layout={layout} isOpen={isRightSidebarOpen}>
      {layout === AppLayout.Mobile && isRightSidebarOpen && (
        <CloseRightSidebar onClick={() => toggleRightSidebar(false)}>
          <CloseIcon />
        </CloseRightSidebar>
      )}

      <Tabs sx={{ flexShrink: 0 }} value={activeTab} onChange={(_, value) => setActiveTab(value)}>
        {topic?.areRemarksAvailable && <Tab label="Remarks" value={SidebarTab.Remarks} />}

        <Tab
          label={
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <span>Participants</span>

              {masterRequestCount > 0 && (
                <Badge badgeContent={masterRequestCount} color="warning">
                  <WavingHandIcon color="warning" />
                </Badge>
              )}
            </Stack>
          }
          value={SidebarTab.Participants}
        />
      </Tabs>

      <RightSidebarContent>
        {activeTab === SidebarTab.Remarks && <Remarks />}

        {activeTab === SidebarTab.Participants && <Participants />}
      </RightSidebarContent>
    </RightSidebarRoot>
  );
}

export default observer(RightSidebar);
